// Adds `seiva-chat-open` to <body> while this element is in the DOM.
// Attach via `phx-hook="ChatOpenSignal"` on a container that is only rendered
// while a Matthew-style chat (Matthew drawer, App Builder chat, Tool Builder
// chat) is open. Multiple concurrent hooks are reference-counted via a data
// attribute so the class is only removed when the last one unmounts.
const ChatOpenSignal = {
  mounted() {
    const body = document.body
    const count = parseInt(body.dataset.seivaChatOpenCount || "0", 10) + 1
    body.dataset.seivaChatOpenCount = String(count)
    body.classList.add("seiva-chat-open")
  },
  destroyed() {
    const body = document.body
    const count = Math.max(0, parseInt(body.dataset.seivaChatOpenCount || "0", 10) - 1)
    body.dataset.seivaChatOpenCount = String(count)
    if (count === 0) body.classList.remove("seiva-chat-open")
  }
}

export default ChatOpenSignal
